import { Controller } from '@hotwired/stimulus'
import mermaid from 'mermaid'

export default class extends Controller {
  static targets = ['container', 'button']
  static values = { initialized: Boolean }

  connect() {
    mermaid.initialize({ startOnLoad: false })
    this.initializedValue = false
  }

  async toggle() {
    this.containerTarget.classList.toggle('invisible')

    const isVisible = !this.containerTarget.classList.contains('invisible')

    if (!this.initializedValue && isVisible) {
      await mermaid.run({ nodes: [this.containerTarget] })

      const svg = this.containerTarget.querySelector('svg')
      if (svg) {
        svg.removeAttribute('width')
        svg.removeAttribute('height')
        svg.style.width = '100%'
        svg.style.maxWidth = '100%'
        svg.style.height = 'auto'
        svg.style.display = 'block'
        svg.style.margin = '0 auto'
      }

      this.initializedValue = true
    }

    // 🔁 Update button label and icon
    const button = this.buttonTarget
    const span = this.buttonTarget.querySelector('span')
    const svgPath = this.buttonTarget.querySelector('svg path')

    if (span) {
      span.textContent = isVisible ? 'Hide Decision Tree' : 'Show Decision Tree'
    }

    if (svgPath) {
      const plusIcon =
        'M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z'
      const minusIcon =
        'M4.75 9.25a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5H4.75Z'

      svgPath.setAttribute('d', isVisible ? minusIcon : plusIcon)
    }
  }
}
